import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookie from "js-cookie";
import store from '../store/index.js'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Profile from '../views/Profile.vue'
import Artist from '../views/Artist.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/a/:slug',
    name: 'artist',
    component: Artist,
    meta: {
    }/*,
    beforeEnter: (to, from, next) => {
      function isValid (slug) {
        return slug == "simpa-doo";
      }
  
      if (!isValid(to.params.slug)) {
        next(false);
      } else {
        next();
      }
    }*/
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  // resolve indicated authentication
  if(store.getters.isAuthenticated !== true && Cookie.get("authed")) {
    await store.dispatch("verify_auth");
  }
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated !== true) {
        next({
            path: '/login',
            params: { nextUrl: to.fullPath }
        })
    } else {
        let user = store.user;
        if(to.matched.some(record => record.meta.is_admin)) {
            if(user.is_admin == 1){
                next()
            }
            else{
                next({ name: 'profile'})
            }
        }else {
            next()
        }
    }
  } else if(to.matched.some(record => record.meta.guest)) {
      if(store.getters.isAuthenticated == false){
          next()
      }
      else{
          next({ name: 'userboard'})
      }
  }else {
      next() 
  }
})


export default router
